import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import Header from "./content/header"
import Logo from "../../assets/img/logo4.jpg"
import api from "../../services/api"
import { login } from "../../services/auth"

class LoginAdmin extends Component {

    constructor(props){
        super(props);

       
    }
    state = {
        email: "",
        password: "",
        error: ""
      };


    handleSignIn = async e => {
        e.preventDefault();
        const { email, password } = this.state;
        if (!email || !password) {
            this.setState({ error: "Preencha e-mail e senha para continuar!" });
            
    } else {
        const { email, password } = this.state;
        const response = await api.post("/login", { email, password });

     
        
        if(response.data.error=='Unauthorised'){
            this.setState({ error: "Acesso não autorizado!" });
        }else{
            login(response.data.success.token);
            this.props.history.push("/user");
        }

      }



    }

  render() {
    return (
      <React.Fragment>
        <div class="container col-lg-4 p-4">     
        

<form class="text-center border border-light p-5" action="#!" onSubmit={this.handleSignIn}>

<h5 class="card-header warning-color white-text text-center py-4 text-text-black-50">
    <strong>Olga Mettig</strong>
  </h5>

<br></br>
{this.state.error && <p>{this.state.error}</p>}

    <input type="email" id="defaultLoginFormEmail" class="form-control mb-4" placeholder="E-mail" onChange={e => this.setState({ email: e.target.value })} />

  
    <input type="password" id="defaultLoginFormPassword" class="form-control mb-4" placeholder="Password" onChange={e => this.setState({ password: e.target.value })} />

    <div class="d-flex justify-content-around">
        
        <div>
            
            <a href="">Forgot password?</a>
        </div>
    </div>

    
    <button class="btn btn-warning btn-block my-4 text-black-50" type="submit">Entrar</button>
      
</form>

    </div>
      </React.Fragment>
       
    );
  }
}

export default withRouter(LoginAdmin);


// WEBPACK FOOTER //
// ./src/pages/User/login.js